import React from 'react';
import Banner from './../Banner/Banner';
import ClinicalFacts from './../ClinicalFacts/ClinicalFacts';
import ContactHome from './../Contact/ContactHome';
import Feature from './../Feature/Feature';
import Menu from './../Menu/Menu';
import QualityService from './../QualityService/QualityService';
import Services from './../Services/Services';
import Helmet from 'react-helmet';
import withLazyLoad from './../LazyLoad/withLazyLoad'; // Correct path to your HOC

const Home = () => {
  const LazyClinicalFacts = withLazyLoad(ClinicalFacts);

  return (
    <>
      <Helmet>
        {/* Primary Meta Tags */}
        <title>
          Zahnarzt Salzburg | Dr. Alshoutaiui | Digitale ZahnarztPraxis
        </title>
        <meta
          name="description"
          content="Moderne Zahnarztpraxis in Salzburg: Schmerzfreie Behandlungen, digitale Diagnostik & Implantologie. Termine unter +43 660 1234567 | Roseggerstraße 23, 5020 Salzburg"
        />
        <meta
          name="keywords"
          content="Zahnarzt Salzburg, Hassan Salzburg,  Digitalezahnpraxis, Zahnpraxis, Hassan Alshoutaiui, zahnarzt hassan, digitalezahnpraxis, zahnarztpraxis, zahnarzt hassan, hassan, Zahnbehandlung, Zahnimplantate, Dentalchirurgie, Zahnarztpraxis, Dr. Alshoutaiui, Notfall Zahnarzt"
        />

        {/* OpenGraph/Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="de_AT" />
        <meta
          property="og:site_name"
          content="Digitale Zahnpraxis Dr. Alshoutaiui"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@zahnarzt_salzburg" />

        {/* Geo-Region */}
        <meta name="geo.region" content="AT-5" />
        <meta name="geo.placename" content="Salzburg" />

        {/* Canonical */}
        <link rel="canonical" href="https://digitalezahnpraxis.at" />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'DentalClinic',
            name: 'Digitale Zahnpraxis Dr. Alshoutaiui',
            image: [
              'https://zahnarztpraxishassan.web.app/static/media/banner1.551c524c16f5053901b2.jpg',
              'https://zahnarztpraxishassan.web.app/static/media/clinic-interior.jpg',
            ],
            priceRange: '$$',
            address: {
              '@type': 'PostalAddress',
              streetAddress: 'Roseggerstraße 23',
              addressLocality: 'Salzburg',
              postalCode: '5020',
              addressCountry: 'AT',
            },
            geo: {
              '@type': 'GeoCoordinates',
              latitude: 47.8025,
              longitude: 13.0472,
            },
            telephone: '+436601234567',
            openingHoursSpecification: {
              '@type': 'OpeningHoursSpecification',
              dayOfWeek: [
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
              ],
              opens: '08:00',
              closes: '18:00',
            },
          })}
        </script>
      </Helmet>

      {/* Remove LazyLoad wrappers but keep components */}
      <Menu />
      <Banner />
      <Feature />
      <QualityService />
      <Services home />
      <LazyClinicalFacts />
      <ContactHome />
    </>
  );
};

export default Home;
